import { gql } from '@apollo/client';

export const USERS = gql`
  query usersAdminAosPods($filters: AdminSearchInput) {
    users(filters: $filters) {
      count
      users {
        id
        displayName
      }
    }
  }
`;

export const PODS = gql`
  query Pods($filters: PodFiltersInput) {
    pods(filters: $filters) {
      pods {
        id
        name
        type
        streamId
        podLeadId
        isActive
        stream {
          id
          name
        }
        podLead {
          id
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;

export const POD_MEMBERS = gql`
  query PodMembers($podId: ID!, $filters: PodMembersFiltersInput) {
    podMembers(podId: $podId, filters: $filters) {
      assignments {
        id
        employeeId
        podId
        podRole
        allocationPct
        isPrimary
        startDate
        endDate
        changeReason
        pod {
          id
          name
          type
        }
        employee {
          id
          firstName
          lastName
          email
          profileImage
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;

export const EMPLOYEE_ASSIGNMENTS = gql`
  query EmployeeAssignments($employeeId: ID!, $filters: PodMembersFiltersInput) {
    employeeAssignments(employeeId: $employeeId, filters: $filters) {
      assignments {
        id
        podId
        podRole
        allocationPct
        isPrimary
        startDate
        endDate
        changeReason
        pod {
          id
          name
          type
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;

export const PROJECTS = gql`
  query projectsAosPods($filters: ProjectsFilterInput) {
    projects(filters: $filters) {
      count
      projects {
        id
        name
      }
    }
  }
`;

export const POD_PROJECTS = gql`
  query PodProjects($podId: ID!, $filters: PodProjectFiltersInput) {
    podProjects(podId: $podId, filters: $filters) {
      podProjects {
        id
        podId
        projectId
        assignedBy
        assignedAt
        project {
          id
          name
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;
